import React from "react"
import Form from "react-bootstrap/Form";
import Col from "react-bootstrap/Col";
import Card from "react-bootstrap/Card";
import Row from "react-bootstrap/Row";
import classes from "./Settings.module.css"

function PushNotifications({ notifications, handleCheckUpdate }) {

    return (
        <Card className={`${classes.cardWidth} mb-5 shadow px-5`}>
            <Card.Body>
                <h4> Push Notification Settings </h4>
                <p> Control what alerts you and clients receive.</p>
                <hr class="mt-1 mb-4" />
                {notifications && Object.entries(notifications).map(([name, value]) => {
                    let checked;
                    let dbField = name;
                    let displayName; 
                    
                    if (name==="progress_pic_added") {
                        displayName="Progress Picture Added"
                    } else {
                        displayName = name.split("_").join(" ")
                    }

                    if (value == "1" || value === true) {
                        checked = true
                    } else {
                        checked = false;
                    }

                    if (notifications) {
                        return (
                            <Row key={name} className="d-flex align-items-center justify-content-center mb-3">
                                <Col >
                                    <div className="d-flex align-items-center" style={{ textTransform: "capitalize" }}>
                                        {displayName}
                                    </div>
                                </Col>
                                <Col >
                                        <Form.Group className="mb-0" controlId={name}>
                                            <Form.Check className="" name={name} onChange={(e) => {
                                                let name = e.target.name
                                                let currCheck = e.target.checked
                                                handleCheckUpdate(name, currCheck, "updateNotificationSetting", dbField)
                                            }}

                                                checked={checked} type="checkbox" className="custom-control custom-checkbox" >
                                            </Form.Check >
                                        </Form.Group>
                                </Col>
                            </Row>
                        )
                    }
                })}


            </Card.Body>

        </Card>
    )
}

export default PushNotifications;
